import { roAboutText } from "./roAboutText";
import { ukAboutText } from "./ukAboutText.js";
import { ruAboutText } from "./ruAboutText.js.js";
import { useAppStore } from "../../store/useAppStore";
import { t } from "../../utils/utils.js";

const aboutText = {
  uk: ukAboutText,
  ro: roAboutText,
  ru: ruAboutText,
};

export function About() {
  const { appLang } = useAppStore();
  return (
    <div className="about cont1">
      <div className="aboutBanner"></div>

      <div className="head1">{t.aboutUs}</div>

      {aboutText[appLang]}
    </div>
  );
}
